// ── Element UI 按需引入（2026-10-03）──────────────────────────────────────────
// 背景：main.js 原来 `Vue.use(ElementUI)` 是全量注册。element-ui 的入口是 CJS
// （lib/element-ui.common.js），webpack 无法 tree-shake —— 没用到的大件
// （el-table / el-date-picker / el-cascader / el-upload / el-tree …）也全被
// 打进首屏 chunk-vendors（占 458KB gz 的绝大部分），而登录页只需要几个表单组件。
//
// 维护约定：模板里新增 <el-xxx> 必须在本文件补注册，否则该页报
//   "Unknown custom element" 并渲染为空白。全量清单查法（仓库根目录）：
//   grep -rhoE "<el-[a-z-]+" src --include=*.vue --include=*.js | sort -u
// 程序化调用（this.$message / $confirm / $prompt / $alert / $notify、v-loading）
// 也在这里注册 —— 见文件末尾。
import Vue from 'vue'

// 基础组件
import Button from 'element-ui/lib/button'
import Row from 'element-ui/lib/row'
import Col from 'element-ui/lib/col'
import Container from 'element-ui/lib/container'
import Header from 'element-ui/lib/header'
import Main from 'element-ui/lib/main'
import Footer from 'element-ui/lib/footer'
// 表单
import Form from 'element-ui/lib/form'
import FormItem from 'element-ui/lib/form-item'
import Input from 'element-ui/lib/input'
import Select from 'element-ui/lib/select'
import Option from 'element-ui/lib/option'
import Switch from 'element-ui/lib/switch'
import Slider from 'element-ui/lib/slider'
import RadioGroup from 'element-ui/lib/radio-group'
import RadioButton from 'element-ui/lib/radio-button'
// 展示/交互
import Dialog from 'element-ui/lib/dialog'
import Popover from 'element-ui/lib/popover'
import Tooltip from 'element-ui/lib/tooltip'
import Tag from 'element-ui/lib/tag'
import Progress from 'element-ui/lib/progress'
// 程序化 API（模板里 this.$xxx / v-loading 依赖下面的挂载）
import Loading from 'element-ui/lib/loading'
import Message from 'element-ui/lib/message'
import MessageBox from 'element-ui/lib/message-box'
import Notification from 'element-ui/lib/notification'

const components = [
  Button, Row, Col, Container, Header, Main, Footer,
  Form, FormItem, Input, Select, Option, Switch, Slider, RadioGroup, RadioButton,
  Dialog, Popover, Tooltip, Tag, Progress
]

components.forEach(component => Vue.component(component.name, component))

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message

export default { Message, MessageBox, Notification, Loading }
